import React from 'react'
import { Link } from "react-router-dom";
import { FaCogs, FaUserAlt, FaCertificate, FaTools, FaRocket, FaHandshake, FaListAlt, FaBalanceScale, FaCheck } from "react-icons/fa"

const services = [
    {
        icon: <FaCogs size={"1.5em"} />,
        title: "Diverse Machining",
        body: "Cedonia has been in the business of custom machining since 1996. We have the capabilities to design and manufacture complex, high precision parts, products and sub-assemblies to meet the diverse needs of our equally varied client base. We have fabricated components for businesses in:",
        items: ["Automotive", "Aerospace", "Nuclear", "Military", "Pharmaceutical", "Mining", "Pipe Evaluation / Inspection", "Construction", "Technical skills upgradation"],
    },
    {
        icon: <FaUserAlt size={"1.5em"} />,
        title: "Core Capabilities",
        body: "With the latest, future-ready machines and over 240 years of collective experience and technical expertise, Cedonia is well-equipped to handle conventional machining, precision machining, as well as custom machining requests in Toronto and the Greater Toronto Area. These include:",
        items: ["Conventional Turning / Milling", "MIG / TIG Welding", "Grinding", "Boring", "Cutting", "Drilling", "CNC Turning 2 to 4 axis / CNC Milling 2 to 5 axis simultaneous", "CNC Sink EDM 4 axis / CNC Wire EDM up to 16.5in high", "CAD / CAM"],
    },
    {
        icon: <FaTools size={"1.5em"} />,
        title: "Materials",
        body: "We have successfully worked with a variety of materials, including:",
        items: ["Carbon Steel", "Stainless Steel", "Tool Steel", "Plastics", "Aluminum", "Brass", "Bronze", "Other Hardened Alloys"],
        note: "If you have any other materials in mind, we can definitely customize the delivery based on your exact requirements.",
    },
    {
        icon: <FaHandshake size={"1.5em"} />,
        title: "Ancillary Services",
        body: "Over the years, our clients have become a part of the extended family at Cedonia. Due to the long association with many of our loyal customers, we have gained a deep understanding of their businesses. This, in turn, led to the introduction of certain ancillary services that we could deliver through our existing capabilities. Today, we are happy to extend these services to all our clients, old and new:",
        items: ["Heat Treatment", "Laser Engraving", "Anodizing/Plating", "Passivation & Sanitization"],
    },
    {
        icon: <FaCertificate size={"1.5em"} />,
        title: "Quality Control Measures",
        body: "When it comes to machining and fabrication, both, quality and precision are paramount. At Cedonia, we have put in place stringent quality control measures, and are proud to meet world-class industry standards:",
        items: ["ISO 9001:2015 registered", "CSA Z299.3 compliant"],
    },
    {
        icon: <FaRocket size={"1.5em"} />,
        title: "Lead Times",
        body: "While we deliver standard requirements in 1 to 4 weeks based on the nature of the project, do not hesitate to check with us about a rush delivery, as and when you need one.",
    },
];

const equipment = [
    "(2x) DECKEL MAHO DMU 100T CNC CONTINUOUS 5 AXIS MILLING CENTRE (Travels: X = 40in Y = 28in, Z = 28in, C and B Axis)",
    "(1x) DECKEL MAHO DMU 85 MONOBLOCK, CNC CONTINUOUS 5 AXIS MILLING CENTRE (Travels: X = 37in Y = 33.5in, Z = 26in, C and A Axis)",
    "(1x) DECKEL MAHO DMU 65 MONOBLOCK, CNC CONTINUOUS 5 AXIS MILLING CENTRE (Travels: X = 29in Y = 25.5in, Z = 22in, C and A Axis)",
    "(1x) DECKEL MAHO DMU60 CNC CONTINUOUS 5 AXIS MILLING CENTRE (Travels: X = 29in Y = 22in, Z = 22in, C and B Axis)",
    "(1x) HAAS VF6 CNC VERTICAL MACHINING CENTRE (Travels: X = 64in Y = 32in, Z = 38in, +C Axis)",
    "(1x) HAAS VF5 CNC VERTICAL MACHINING CENTRE (Travels: X = 50in Y = 26in, Z = 28in, +C Axis)",
    "(1x) HAAS VF4 CNC VERTICAL MACHINING CENTRE (Travels: X = 50in Y = 20in, Z = 28in, +C Axis)",
    "(1x) FORTUNE CNC LATHE (Turning Dia = 20in x 50in, Bar Capacity: 3.5in)",
    "(1x) MAZAK 450M, 2+1 AXIS CNC TURNING/ MILLING CENTER (Dia = 25 x 40in, 4.5in Bore)",
    "(1x) MAZAK Quick Turn 250, CNC LATHE (Dia = 12in x 25in)",
    "(1x) MAZAK 200 MSY,4 AXIS CNC TURNING/ MILLING CENTER, Y Axis and Sub Spindle (Dia = 12in)",
    "(1x) CHARMILLE CNC SINK EDM (Travels: X = 24in Y = 16in, Z = 18in)",
    "(1x) AGIE CHARMILLE CNC DRILL 20 (Travels: X = 16in Y = 10in, Z = 14in)",
    "(1x) SODICK WIRE EDM (Travels: X = 20in Y = 14in, Z = 13in)",
    "(1x) AGIE CLASSIC 3 CNC WIRE EDM (Travels: X = 20in Y = 14in, Z = 16.8in)",
    "CMM- CNC-ZEISS CONTURA (28in X 40in X 23in)",
    "CMM- CNC-ZEISS DURAMAX (20in X 20in X 20in)",
    "POLI-MANUAL CMM (28in X 30in X 18in)",
    "(2x) CONVENTIONAL LATHES",
    "24in Swing X 160in",
];

export default function Services() {
    return (
        <div className='bg-zinc-50 text-zinc-900'>
            <section className='bg-white px-4 py-16 sm:px-6 lg:px-8 lg:py-20'>
                <div className='mx-auto max-w-7xl text-center'>
                    <p className='text-sm font-semibold uppercase tracking-[0.24em] text-red-600'>Cedonia</p>
                    <h1 className='mt-4 text-5xl font-extrabold tracking-tight text-zinc-950 sm:text-6xl'>Our Services</h1>
                    <p className='mx-auto mt-5 max-w-3xl text-lg leading-8 text-zinc-600'>
                        Precision machining, tooling, project support, and quality control for demanding custom requirements.
                    </p>
                    <div className='mt-8'>
                        <Link to="/contact" className='inline-flex rounded-md bg-red-600 px-6 py-3 text-base font-semibold text-white shadow-sm shadow-red-900/10 transition duration-200 hover:-translate-y-0.5 hover:bg-red-700 hover:shadow-lg hover:shadow-red-900/15'>
                            Start a Project
                        </Link>
                    </div>
                </div>
            </section>

            <section className='px-4 py-12 sm:px-6 lg:px-8 lg:py-16'>
                <div className='mx-auto grid max-w-7xl gap-5 lg:grid-cols-2'>
                    {services.map((service) => (
                        <article className='group rounded-lg border border-zinc-200 bg-white p-6 shadow-sm transition duration-200 hover:-translate-y-1 hover:border-red-100 hover:shadow-xl hover:shadow-zinc-900/10 sm:p-8' key={service.title}>
                            <div className='flex items-start gap-5'>
                                <div className='flex h-14 w-14 shrink-0 items-center justify-center rounded-md bg-zinc-950 text-white transition duration-200 group-hover:bg-red-600'>
                                    {service.icon}
                                </div>
                                <div>
                                    <h2 className='text-2xl font-bold tracking-tight text-zinc-950'>{service.title}</h2>
                                    <p className='mt-3 text-base leading-7 text-zinc-600'>{service.body}</p>
                                </div>
                            </div>
                            {service.items && (
                                <div className='mt-6 grid gap-3 sm:grid-cols-2'>
                                    {service.items.map((item) => (
                                        <p className='rounded-md bg-zinc-50 px-3 py-2 text-sm font-semibold leading-6 text-zinc-800' key={item}>
                                            <FaCheck className='mr-2 inline-block text-red-600' size={"0.85em"} />{item}
                                        </p>
                                    ))}
                                </div>
                            )}
                            {service.note && <p className='mt-5 text-base leading-7 text-zinc-600'>{service.note}</p>}
                        </article>
                    ))}
                </div>
            </section>

            <section className='bg-white px-4 py-12 sm:px-6 lg:px-8 lg:py-16'>
                <div className='mx-auto grid max-w-7xl gap-8 lg:grid-cols-[0.75fr_1.25fr] lg:items-start'>
                    <div className='rounded-lg border border-zinc-200 bg-zinc-950 p-8 text-white shadow-xl shadow-zinc-900/10'>
                        <div className='flex h-14 w-14 items-center justify-center rounded-md bg-red-600'>
                            <FaBalanceScale size={"1.5em"} />
                        </div>
                        <h2 className='mt-6 text-3xl font-bold tracking-tight'>CNC Machining Versus Conventional Machining</h2>
                    </div>
                    <div className='space-y-5 text-base leading-8 text-zinc-600'>
                        <p>At Cedonia, we can deliver precision prototypes, as well as high volume requirements. For better production efficiencies, reduced cycle times, and identical construction of simple, or complex components, consider our CNC machining services in Mississauga. Due to their automated, programmable, computer-controlled features, CNC machines deliver consistent results for all your prototypes and mass fabrication requirements.</p>
                        <p>However, if you require unique, custom pieces, reprogramming the CNC machines is time-consuming, tedious and costly. At such times, conventional machining is the way to go. Our highly-skilled technicians look forward to understanding your precision and quality requirements. Rest assured, we will deliver the products you need at unmatched speed and highly competitive prices.</p>
                        <p>To know more about our machining capabilities and how we can serve you better, give us a call today.</p>
                    </div>
                </div>
            </section>

            <section className='px-4 py-12 sm:px-6 lg:px-8 lg:py-16'>
                <div className='mx-auto max-w-7xl rounded-lg border border-zinc-200 bg-white p-6 shadow-xl shadow-zinc-900/5 sm:p-8 lg:p-10'>
                    <div className='flex flex-col gap-5 md:flex-row md:items-start md:justify-between'>
                        <div>
                            <div className='flex h-14 w-14 items-center justify-center rounded-md bg-red-600 text-white'>
                                <FaListAlt size={"1.5em"} />
                            </div>
                            <h2 className='mt-5 max-w-4xl text-3xl font-bold tracking-tight text-zinc-950'>Equipment List for Machining Capabilities</h2>
                            <p className='mt-3 text-base leading-7 text-zinc-600'>Here is an indicative list of the equipment at our 28,000 square foot facility in Mississauga, Ontario:</p>
                        </div>
                    </div>
                    <div className='mt-8 grid gap-3 lg:grid-cols-2'>
                        {equipment.map((item) => (
                            <p className='rounded-md bg-zinc-50 px-4 py-3 text-sm font-semibold leading-6 text-zinc-800' key={item}>
                                <FaCheck className='mr-2 inline-block text-red-600' size={"0.85em"} />{item}
                            </p>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    )
}
